import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
const useStyles = makeStyles(theme => ({
  root: {
    marginTop: "1px",
    marginBottom: "1px"
  },
  leftChoice: {
    marginRight: "50px"
  }
}));
const TripleToggle = props => {
  const classes = useStyles();
  const [termsChoice, setTermsChoice] = useState(props.defaultValue ? "1" : "");
  const handleRadioChange = e => {
    setTermsChoice(e.target.value);
    props.toggleAction(props.toggleType, e.target.value);
  };
  return /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset",
    className: classes.root
  }, /*#__PURE__*/React.createElement(RadioGroup, {
    row: true,
    "aria-label": "position",
    name: "terms_choice",
    value: termsChoice,
    onChange: handleRadioChange,
    defaultValue: ""
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    className: classes.leftChoice,
    value: "1",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: props.yesLabel,
    labelPlacement: "start"
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "0",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "secondary"
    }),
    label: props.noLabel,
    labelPlacement: "end"
  })));
};
TripleToggle.propTypes = {
  toggleType: PropTypes.string,
  toggleAction: PropTypes.func,
  yesLabel: PropTypes.string,
  noLabel: PropTypes.string
};
export default TripleToggle;